module.exports = __webpack_public_path__ + "img/T85.917c909a.jpg";